import type { INotification } from '../../../Interfaces/INotification';
import {
  IRequestNotificationsAction,
  IReceiveNotificationsAction,
  IErrorNotificationsAction,
  IMarkReadRequestAction,
  IMarkReadSuccessAction,
  IMarkAllReadRequestAction,
  IMarkAllReadSuccessAction,
  PBTNotificationsActionType,
} from './action-types';

export function requestNotifications(): IRequestNotificationsAction {
  return {
    type: PBTNotificationsActionType.REQUEST_NOTIFICATIONS,
  };
}

export function receiveNotifications(data: INotification[], unreadCount: number): IReceiveNotificationsAction {
  return {
    type: PBTNotificationsActionType.RECEIVE_NOTIFICATIONS,
    data,
    unreadCount,
  };
}

export function sendNotificationsError(errorMessage: string): IErrorNotificationsAction {
  return {
    type: PBTNotificationsActionType.ERROR_NOTIFICATIONS,
    errorMessage,
  };
}

export function markNotificationReadRequest(notificationId: number): IMarkReadRequestAction {
  return {
    type: PBTNotificationsActionType.MARK_READ_REQUEST,
    notificationId,
  };
}

export function markNotificationReadSuccess(notificationId: number): IMarkReadSuccessAction {
  return {
    type: PBTNotificationsActionType.MARK_READ_SUCCESS,
    notificationId,
  };
}

export function markAllNotificationsReadRequest(): IMarkAllReadRequestAction {
  return {
    type: PBTNotificationsActionType.MARK_ALL_READ_REQUEST,
  };
}

export function markAllNotificationsReadSuccess(): IMarkAllReadSuccessAction {
  return {
    type: PBTNotificationsActionType.MARK_ALL_READ_SUCCESS,
  };
}
